import * as React from "react"

import { ReactComponent as OnboardSvg } from 'resources/icons/space/onboard_solid.svg'

import * as st from './ValueAndCustomers.styled.js'

const ValueAndCustomers = () => (
  <st.Wrap
    color="red"
    Icon={OnboardSvg}
  >
    <st.Content>
      <st.TitleCustomersWrap>
        <st.Title>
          Supercharge <ins>SMB</ins> and <ins>Enterprise</ins> customer onboarding
        </st.Title>
        <st.CustomersWrap>
          <st.CustomersTitle>
            Trusted by companies of all shapes and sizes
          </st.CustomersTitle>
          <st.CustomersGrid>
            <st.CustomerCell>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/partstech.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/partstech.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/customers/v2/partstech@2x.png 2x"
                width={137}
                height={34}
                alt="PartsTech"
              />
            </st.CustomerCell>

            <st.CustomerCell>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/payabli.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/payabli.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/customers/v2/payabli@2x.png 2x"
                width={138}
                height={41}
                alt="Payabli"
              />
            </st.CustomerCell>

            <st.CustomerCell>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/kodif.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/kodif.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/customers/v2/kodif@2x.png 2x"
                width={130}
                height={25}
                alt="Kodif"
              />
            </st.CustomerCell>

            <st.CustomerCell>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/trucksite.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/trucksite.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/customers/v2/trucksite@2x.png 2x"
                width={144}
                height={27}
                alt="Truck Site"
              />
            </st.CustomerCell>

            <st.CustomerCell>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/thinkie.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/thinkie.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/customers/v2/thinkie@2x.png 2x"
                width={130}
                height={33}
                alt="Thinkie"
              />
            </st.CustomerCell>

            <st.CustomerCell>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/shed.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/logos/customers/v2/shed.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/customers/v2/shed@2x.png 2x"
                width={110}
                height={32}
                alt="The Shed Creative"
              />
            </st.CustomerCell>
          </st.CustomersGrid>
        </st.CustomersWrap>
      </st.TitleCustomersWrap>

      <st.ValuesWrap>
        <st.ValueBlock gap={22}>
          <st.ValueImageWrap>
            <img
              src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/team-capacity.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/team-capacity.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-values/team-capacity@2x.png 2x"
              width={109}
              height={42}
              alt="Increase Team Capacity"
            />
          </st.ValueImageWrap>
          <st.ValueText>Increase Team Capacity</st.ValueText>
        </st.ValueBlock>

        <st.ValueBlock gap={16}>
          <st.ValueImageWrap>
            <img
              src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/csat.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/csat.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-values/csat@2x.png 2x"
              width={119}
              height={54}
              alt="Improve CSAT"
            />
          </st.ValueImageWrap>
          <st.ValueText>Improve CSAT</st.ValueText>
        </st.ValueBlock>

        <st.ValueBlock gap={14}>
          <st.ValueImageWrap>
            <img
              src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/engagement.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/engagement.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-values/engagement@2x.png 2x"
              width={61}
              height={64}
              alt="Boost Customer Engagement"
            />
          </st.ValueImageWrap>
          <st.ValueText>Boost Customer Engagement</st.ValueText>
        </st.ValueBlock>

        <st.ValueBlock gap={20.5}>
          <st.ValueImageWrap>
            <img
              src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/ttv.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-values/ttv.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-values/ttv@2x.png 2x"
              width={186}
              height={49}
              alt="Accelerate Time to Live"
            />
          </st.ValueImageWrap>
          <st.ValueText>Accelerate Time to Live</st.ValueText>
        </st.ValueBlock>
      </st.ValuesWrap>
    </st.Content>
  </st.Wrap>
)

export default ValueAndCustomers
